import React, { createContext, useState, useContext, useEffect } from "react";
import API from "./api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [sessionErrorMessage, setSessionErrorMessage] = useState("");

  useEffect(() => {
    // Global Axios response interceptor
    API.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
          logout(); // Logout automatically on token expiration
        }
        return Promise.reject(error);
      }
    );
  }, []);

  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await API.get("/auth/check-session");
        if (response.data.user) {
          setUser(response.data.user);
          setIsAuthenticated(true);
          console.log("user...........session");
          console.log(response.data.user);

          return true; // Session is valid
        } else {
          setUser(null);
          setIsAuthenticated(false);
          return false; // No valid session
        }
      } catch (error) {
        setSessionErrorMessage("Session expired");
        setUser(null);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };
    checkSession();
  }, []);

  const login = async (email, password) => {
    setIsLoading(true);
    setErrorMessage(""); // Clear previous errors
    try {
      const response = await API.post("/auth/login", { email, password }); // Adjusted to /login
      setUser(response.data.user);
      console.log(response.data.user);

      setIsAuthenticated(true);
    } catch (error) {
      throw error; // Re-throw to allow Login component to catch it // Pass error to caller
    } finally {
      setIsLoading(false);
    }
  };

  // const logout = async () => {
  //   try {
  //     await API.post("/auth/logout");
  //     setUser(null);
  //     setIsAuthenticated(false);
  //     localStorage.clear(); // Consider more specific clearing if needed.
  //     // window.location.reload(); // Consider alternatives to full page reload.
  //   } catch (error) {
  //     if (error.response?.data?.message) {
  //       setErrorMessage(error.response.data.message);
  //     } else {
  //       setErrorMessage("Logout failed. Please try again later.");
  //     }
  //   }
  // };

  const logout = async () => {
    try {
      await API.post("/auth/logout"); // Call backend logout route

      // Clear user-related state
      setUser(null);
      setIsAuthenticated(false);
      localStorage.clear();

      // Optional: redirect after logout
      // navigate("/login");
    } catch (error) {
      // Use backend error message if available or fallback message
      const message =
        error.response?.data?.message ||
        "Logout failed. Please try again later.";
      setErrorMessage(message);
    }
  };

  const updateUser = (newUserData) => {
    setUser((prevUser) => ({ ...prevUser, ...newUserData }));
  };

  const clearSessionErrorMessage = () => {
    setSessionErrorMessage("");
  };

  console.log("Auth:", {
    isLoading,
    isAuthenticated,
    user,
  });

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated,
        isLoading,
        errorMessage,
        sessionErrorMessage,
        clearSessionErrorMessage,
        login,
        logout,
        updateUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
